import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { getGeneralStatistics } from '../actions/adminActions'


class Home extends React.Component {

    constructor() {
        super();
    }
        
    componentDidMount() {
        // calling the new action creator
        this.props.localGetGeneralStatistics();
    }

    render() {

        const { general } = this.props;

         
              
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4">
                        <div className="panel mini">
                            <h4>
                                {typeof general.users !== 'undefined' ?
                                    <div>
                                        {general.users.userCount}<small> Registred users</small><br />
                                        {general.users.botCount}<small> Bots</small><br />
                                    </div>
                                    : 'Loading...'
                                }
                               
                            </h4>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="panel mini">
                            <h4>
                                {typeof general.payments !== 'undefined' ?
                                    <div>
                                        {general.payments.totalDeposits}<small> Deposits total</small><br />
                                        {general.payments.totalDepositsNetAmount}<small> Net amount</small><br />
                                    </div>
                                    : 'Loading...'
                                }
                            </h4>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="panel mini">
                            <h4>
                                {typeof general.payments !== 'undefined' ?
                                    <div>
                                        {general.payments.totalWithdraws}<small> Payed out total</small><br />
                                        {general.payments.totalWithdrawsCompleted}<small> Completed</small><br />
                                        {general.payments.totalWithdrawsRequested}<small> Requested</small><br />
                                       
                                    </div>
                                    : 'Loading...'
                                }
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        general: state.adminReducer.general
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //function
        localGetGeneralStatistics: () => dispatch(getGeneralStatistics()),
    };
}

const home = connect(mapStateToProps, mapDispatchToProps)(Home);
export { home as Home }; 